import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a0924374&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a0924374&lang=scss&scoped=true&"
import style1 from "./style.scss?vue&type=style&index=1&id=a0924374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0924374",
  null
  
)

export default component.exports